import { useState, useEffect } from 'react';
import TopNavbar from '../../components/ui/TopNavbar';
import IssueFilters from './components/IssueFilters';
import IssueDataGrid from './components/IssueDataGrid';



import Button from '../../components/ui/Button';

const IssueAndRiskLog = () => {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [editingIssue, setEditingIssue] = useState(null);
  const [filters, setFilters] = useState({
    severity: 'all',
    category: 'all',
    status: 'all',
    shipment: 'all',
    owner: 'all',
    overdue: false,
    escalated: false,
    hasAttachments: false
  });
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [showDetailsPanel, setShowDetailsPanel] = useState(false);

  const mockIssues = [
  {
    id: 'ISS-2024-001',
    title: 'Quality specification mismatch in coal grade',
    shipmentRef: 'SHP-2024-001',
    severity: 'critical',
    category: 'Quality Issues',
    owner: 'Sarah Chen',
    ownerId: 'sarah-chen',
    status: 'in-progress',
    createdDate: '2024-12-01T08:30:00',
    targetDate: '2024-12-15T17:00:00',
    impact: 'Potential buyer rejection, $50,000 cost exposure',
    description: `Lab analysis results show ash content at 12.5% versus contracted specification of 11.5%. This exceeds the tolerance limit and may result in buyer rejection or price penalty.\n\nImmediate action required to verify results with independent lab and negotiate with buyer on acceptance terms.`,
    rootCause: 'Supplier blending process deviation during loading operations. Quality control sampling was insufficient to detect the variance early.',
    mitigation: `1. Engaged independent lab for verification testing\n2. Initiated discussions with buyer for price adjustment\n3. Implemented enhanced sampling protocol for future shipments\n4. Supplier issued formal notice regarding quality control breach`,
    resolution: null,
    hasAttachments: true,
    escalated: true,
    history: [
    {
      userName: 'Sarah Chen',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1839f83d3-1763293825256.png",
      userAvatarAlt: 'Professional headshot of Asian woman with shoulder-length black hair wearing navy blazer',
      action: 'Created issue and assigned to Operations team',
      timestamp: '2024-12-01T08:30:00',
      comment: null
    },
    {
      userName: 'Michael Rodriguez',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_143b978a3-1763294952544.png",
      userAvatarAlt: 'Professional headshot of Hispanic man with short black hair in navy suit',
      action: 'Updated status to In Progress',
      timestamp: '2024-12-01T14:20:00',
      comment: 'Contacted independent lab for verification. Results expected within 48 hours.'
    },
    {
      userName: 'Sarah Chen',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1839f83d3-1763293825256.png",
      userAvatarAlt: 'Professional headshot of Asian woman with shoulder-length black hair wearing navy blazer',
      action: 'Escalated issue to management',
      timestamp: '2024-12-02T09:15:00',
      comment: 'Buyer has indicated potential rejection. Escalating for commercial negotiation support.'
    }],

    attachments: [
    {
      name: 'Lab_Analysis_Report.pdf',
      size: '2.4 MB',
      uploadedDate: '2024-12-01T08:35:00'
    },
    {
      name: 'Quality_Specification_Contract.pdf',
      size: '1.8 MB',
      uploadedDate: '2024-12-01T08:36:00'
    },
    {
      name: 'Supplier_Response_Email.pdf',
      size: '456 KB',
      uploadedDate: '2024-12-01T16:20:00'
    }],

    relatedIssues: [
    {
      id: 'ISS-2024-008',
      shipmentRef: 'SHP-2024-001',
      title: 'Delayed B/L issuance affecting payment timeline',
      severity: 'medium',
      status: 'open'
    }]

  },
  {
    id: 'ISS-2024-002',
    title: 'Vessel berthing delay at Newcastle Port',
    shipmentRef: 'SHP-2024-002',
    severity: 'high',
    category: 'Logistics Delays',
    owner: 'Michael Rodriguez',
    ownerId: 'michael-rodriguez',
    status: 'open',
    createdDate: '2024-12-03T10:15:00',
    targetDate: '2024-12-10T17:00:00',
    impact: 'Demurrage charges estimated at $15,000 per day',
    description: `MV Ocean Trader experiencing 4-day berthing delay due to port congestion at Newcastle. Current queue position is 3rd with estimated berthing on 08-Dec.\n\nDemurrage will commence from 05-Dec as per laytime calculations. Urgent coordination required with port authority and vessel operator.`,
    rootCause: null,
    mitigation: null,
    resolution: null,
    hasAttachments: true,
    escalated: false,
    history: [
    {
      userName: 'Michael Rodriguez',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_143b978a3-1763294952544.png",
      userAvatarAlt: 'Professional headshot of Hispanic man with short black hair in navy suit',
      action: 'Created issue',
      timestamp: '2024-12-03T10:15:00',
      comment: 'Port authority confirmed congestion due to weather delays last week.'
    }],

    attachments: [
    {
      name: 'Port_Congestion_Notice.pdf',
      size: '890 KB',
      uploadedDate: '2024-12-03T10:20:00'
    }],

    relatedIssues: []
  },
  {
    id: 'ISS-2024-003',
    title: 'LC amendment required for price adjustment',
    shipmentRef: 'SHP-2024-003',
    severity: 'medium',
    category: 'Documentation',
    owner: 'Priya Sharma',
    ownerId: 'priya-sharma',
    status: 'pending-approval',
    createdDate: '2024-12-04T14:30:00',
    targetDate: '2024-12-12T17:00:00',
    impact: 'Payment delay, potential shipment hold',
    description: `Platts pricing window resulted in final price adjustment requiring LC amendment from $4.2M to $4.35M. Buyer bank requires 5 business days for amendment processing.\n\nDocuments ready for submission pending buyer approval on revised commercial terms.`,
    rootCause: null,
    mitigation: null,
    resolution: null,
    hasAttachments: false,
    escalated: false,
    history: [
    {
      userName: 'Priya Sharma',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_131e198e6-1763297816942.png",
      userAvatarAlt: 'Professional headshot of Indian woman with long dark hair wearing white blouse',
      action: 'Created issue and submitted for approval',
      timestamp: '2024-12-04T14:30:00',
      comment: 'Sent LC amendment request to buyer finance team.'
    },
    {
      userName: 'James Wilson',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187ac2848-1764684680250.png",
      userAvatarAlt: 'Professional headshot of Caucasian man with grey hair in dark suit',
      action: 'Reviewed documentation',
      timestamp: '2024-12-05T09:45:00',
      comment: 'All supporting documents verified. Awaiting buyer confirmation.'
    }],

    attachments: [],
    relatedIssues: []
  },
  {
    id: 'ISS-2024-004',
    title: 'Customs clearance documentation incomplete',
    shipmentRef: 'SHP-2024-004',
    severity: 'high',
    category: 'Compliance',
    owner: 'Sarah Chen',
    ownerId: 'sarah-chen',
    status: 'in-progress',
    createdDate: '2024-12-05T11:20:00',
    targetDate: '2024-12-08T17:00:00',
    impact: 'Shipment clearance delay, storage charges',
    description: `Missing certificate of origin and phytosanitary certificate for customs clearance. Supplier has been contacted to provide missing documents urgently.\n\nVessel ETA is 10-Dec, documents must be received by 08-Dec to avoid clearance delays.`,
    rootCause: null,
    mitigation: null,
    resolution: null,
    hasAttachments: true,
    escalated: true,
    history: [
    {
      userName: 'Sarah Chen',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1839f83d3-1763293825256.png",
      userAvatarAlt: 'Professional headshot of Asian woman with shoulder-length black hair wearing navy blazer',
      action: 'Created issue and escalated',
      timestamp: '2024-12-05T11:20:00',
      comment: 'Urgent action required. Supplier response deadline set for 07-Dec.'
    }],

    attachments: [
    {
      name: 'Customs_Requirements_Checklist.pdf',
      size: '1.2 MB',
      uploadedDate: '2024-12-05T11:25:00'
    }],

    relatedIssues: []
  },
  {
    id: 'ISS-2024-005',
    title: 'Payment delay from buyer affecting cash flow',
    shipmentRef: 'SHP-2024-001',
    severity: 'medium',
    category: 'Payment Issues',
    owner: 'James Wilson',
    ownerId: 'james-wilson',
    status: 'open',
    createdDate: '2024-12-06T09:00:00',
    targetDate: '2024-12-13T17:00:00',
    impact: 'Cash flow constraint, supplier payment delay',
    description: `Buyer payment for SHP-2024-001 is overdue by 7 days. LC documents were presented on 25-Nov with 7-day payment terms.\n\nBuyer citing internal approval delays. Follow-up required with buyer finance team.`,
    rootCause: null,
    mitigation: null,
    resolution: null,
    hasAttachments: false,
    escalated: false,
    history: [
    {
      userName: 'James Wilson',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187ac2848-1764684680250.png",
      userAvatarAlt: 'Professional headshot of Caucasian man with grey hair in dark suit',
      action: 'Created issue',
      timestamp: '2024-12-06T09:00:00',
      comment: 'Sent payment reminder to buyer. Awaiting response.'
    }],

    attachments: [],
    relatedIssues: [
    {
      id: 'ISS-2024-001',
      shipmentRef: 'SHP-2024-001',
      title: 'Quality specification mismatch in coal grade',
      severity: 'critical',
      status: 'in-progress'
    }]

  },
  {
    id: 'ISS-2024-006',
    title: 'Inspection agency report discrepancy',
    shipmentRef: 'SHP-2024-002',
    severity: 'low',
    category: 'Quality Issues',
    owner: 'Michael Rodriguez',
    ownerId: 'michael-rodriguez',
    status: 'resolved',
    createdDate: '2024-11-28T13:45:00',
    targetDate: '2024-12-05T17:00:00',
    impact: 'Minor documentation correction required',
    description: `Inspection report shows tonnage as 49,850 MT versus B/L quantity of 50,000 MT. Variance is within acceptable tolerance but requires clarification note from inspector.\n\nInspector has agreed to issue revised report with explanation.`,
    rootCause: 'Rounding difference in measurement methodology between inspector and vessel draft survey.',
    mitigation: 'Obtained clarification letter from inspection agency confirming variance is within acceptable limits.',
    resolution: 'Revised inspection report received with clarification note. Issue closed.',
    hasAttachments: true,
    escalated: false,
    history: [
    {
      userName: 'Michael Rodriguez',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_143b978a3-1763294952544.png",
      userAvatarAlt: 'Professional headshot of Hispanic man with short black hair in navy suit',
      action: 'Created issue',
      timestamp: '2024-11-28T13:45:00',
      comment: null
    },
    {
      userName: 'Michael Rodriguez',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_143b978a3-1763294952544.png",
      userAvatarAlt: 'Professional headshot of Hispanic man with short black hair in navy suit',
      action: 'Updated status to Resolved',
      timestamp: '2024-12-04T16:30:00',
      comment: 'Received revised report with clarification. Variance acceptable.'
    }],

    attachments: [
    {
      name: 'Inspection_Report_Original.pdf',
      size: '3.1 MB',
      uploadedDate: '2024-11-28T13:50:00'
    },
    {
      name: 'Inspection_Report_Revised.pdf',
      size: '3.2 MB',
      uploadedDate: '2024-12-04T16:25:00'
    }],

    relatedIssues: []
  },
  {
    id: 'ISS-2024-007',
    title: 'Supplier invoice discrepancy for inspection costs',
    shipmentRef: 'SHP-2024-003',
    severity: 'low',
    category: 'Operational',
    owner: 'Priya Sharma',
    ownerId: 'priya-sharma',
    status: 'closed',
    createdDate: '2024-11-25T10:30:00',
    targetDate: '2024-12-02T17:00:00',
    impact: 'Minor cost reconciliation adjustment',
    description: `Supplier invoiced $3,200 for inspection costs versus agreed rate of $2,800. Variance due to additional sampling requested by buyer.\n\nCost adjustment approved and processed.`,
    rootCause: 'Additional sampling requirements not communicated in advance to cost estimation.',
    mitigation: 'Updated cost estimation process to include buyer sampling requirements confirmation.',
    resolution: 'Cost variance approved and paid. Process improvement implemented.',
    hasAttachments: false,
    escalated: false,
    history: [
    {
      userName: 'Priya Sharma',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_131e198e6-1763297816942.png",
      userAvatarAlt: 'Professional headshot of Indian woman with long dark hair wearing white blouse',
      action: 'Created issue',
      timestamp: '2024-11-25T10:30:00',
      comment: null
    },
    {
      userName: 'James Wilson',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187ac2848-1764684680250.png",
      userAvatarAlt: 'Professional headshot of Caucasian man with grey hair in dark suit',
      action: 'Approved cost adjustment',
      timestamp: '2024-11-27T14:20:00',
      comment: 'Variance justified. Approved for payment.'
    },
    {
      userName: 'Priya Sharma',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_131e198e6-1763297816942.png",
      userAvatarAlt: 'Professional headshot of Indian woman with long dark hair wearing white blouse',
      action: 'Closed issue',
      timestamp: '2024-12-01T11:15:00',
      comment: 'Payment processed. Issue closed.'
    }],

    attachments: [],
    relatedIssues: []
  },
  {
    id: 'ISS-2024-008',
    title: 'Delayed B/L issuance affecting payment timeline',
    shipmentRef: 'SHP-2024-001',
    severity: 'medium',
    category: 'Documentation',
    owner: 'Sarah Chen',
    ownerId: 'sarah-chen',
    status: 'in-progress',
    createdDate: '2024-12-02T15:20:00',
    targetDate: '2024-12-09T17:00:00',
    impact: 'Payment delay, LC presentation timeline at risk',
    description: `Shipping line has not issued original B/L despite vessel departure 5 days ago. Multiple follow-ups sent with no response.\n\nLC presentation deadline is 12-Dec. Urgent escalation required to shipping line management.`,
    rootCause: null,
    mitigation: null,
    resolution: null,
    hasAttachments: true,
    escalated: true,
    history: [
    {
      userName: 'Sarah Chen',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1839f83d3-1763293825256.png",
      userAvatarAlt: 'Professional headshot of Asian woman with shoulder-length black hair wearing navy blazer',
      action: 'Created issue and escalated',
      timestamp: '2024-12-02T15:20:00',
      comment: 'Contacted shipping line operations manager. Awaiting response.'
    },
    {
      userName: 'Michael Rodriguez',
      userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_143b978a3-1763294952544.png",
      userAvatarAlt: 'Professional headshot of Hispanic man with short black hair in navy suit',
      action: 'Added follow-up action',
      timestamp: '2024-12-04T10:30:00',
      comment: 'Escalated to shipping line regional director. Promised resolution by 06-Dec.'
    }],

    attachments: [
    {
      name: 'Shipping_Line_Correspondence.pdf',
      size: '1.5 MB',
      uploadedDate: '2024-12-02T15:25:00'
    }],

    relatedIssues: [
    {
      id: 'ISS-2024-001',
      shipmentRef: 'SHP-2024-001',
      title: 'Quality specification mismatch in coal grade',
      severity: 'critical',
      status: 'in-progress'
    }]

  }];


  const [filteredIssues, setFilteredIssues] = useState(mockIssues);

  useEffect(() => {
    let result = [...mockIssues];

    if (filters?.severity !== 'all') {
      result = result?.filter((issue) => issue?.severity === filters?.severity);
    }

    if (filters?.category !== 'all') {
      result = result?.filter((issue) => issue?.category === filters?.category);
    }

    if (filters?.status !== 'all') {
      result = result?.filter((issue) => issue?.status === filters?.status);
    }

    if (filters?.shipment !== 'all') {
      result = result?.filter((issue) => issue?.shipmentRef === filters?.shipment);
    }

    if (filters?.owner !== 'all') {
      result = result?.filter((issue) => issue?.ownerId === filters?.owner);
    }

    if (filters?.overdue) {
      result = result?.filter((issue) => {
        const isOverdue = new Date(issue.targetDate) < new Date();
        return isOverdue && issue?.status !== 'resolved' && issue?.status !== 'closed';
      });
    }

    if (filters?.escalated) {
      result = result?.filter((issue) => issue?.escalated);
    }

    if (filters?.hasAttachments) {
      result = result?.filter((issue) => issue?.hasAttachments);
    }

    setFilteredIssues(result);
  }, [filters]);

  const handleAddIssue = () => {
    setShowIssueModal(true);
  };

  const handleSaveIssue = (issueData) => {
    console.log('Saving issue:', issueData);
    // TODO: Implement actual save with Supabase
    alert('✅ Issue/Risk logged successfully!');
    setShowIssueModal(false);
  };

  const handleUpdateIssueStatus = (issueId, newStatus) => {
    console.log('Updating status:', issueId, newStatus);
    // TODO: Implement status update
    alert(`✅ Status updated to ${newStatus}`);
  };

  const handleAssignIssue = (issueId, assignee) => {
    console.log('Assigning issue:', issueId, assignee);
    // TODO: Implement assignment
    alert(`✅ Issue assigned to ${assignee}`);
  };

  const handleFilterChange = (filters) => {
    console.log('Filters applied:', filters);
    // TODO: Apply filter logic
  };

  const handleExportIssues = () => {
    alert(`✅ Exporting ${mockIssues?.length} issues...`);
  };

  const handleViewDetails = (issue) => {
    setSelectedIssue(issue);
    setShowDetailsPanel(true);
  };

  const handleCloseDetails = () => {
    setShowDetailsPanel(false);
    setSelectedIssue(null);
  };

  const handleClearFilters = () => {
    setFilters({
      severity: 'all',
      category: 'all',
      status: 'all',
      shipment: 'all',
      owner: 'all',
      overdue: false,
      escalated: false,
      hasAttachments: false
    });
  };

  const handleSaveFilter = () => {
    console.log('Saving filter configuration:', filters);
    alert('Filter configuration saved successfully!');
  };

  const handleSelectIssue = (issue) => {
    setSelectedIssue(issue);
  };

  const handleEditIssue = (issue) => {
    setEditingIssue(issue);
    setIsFormModalOpen(true);
  };

  const handleUpdateStatus = (issueId, newStatus) => {
    console.log('Updating status:', issueId, newStatus);
    alert(`Status updated to: ${newStatus}`);
  };

  const handleUpdateOwner = (issueId, newOwner) => {
    console.log('Updating owner:', issueId, newOwner);
    alert(`Owner updated to: ${newOwner}`);
  };

  const handleBulkAction = (action) => {
    console.log('Bulk action:', action);
    alert(`Bulk action "${action}" executed successfully!`);
  };

  const handleSearch = (query) => {
    console.log('Searching for:', query);
    if (!query?.trim()) {
      setFilteredIssues(mockIssues);
      return;
    }

    const searchLower = query?.toLowerCase();
    let result = mockIssues?.filter((issue) =>
    issue?.title?.toLowerCase()?.includes(searchLower) ||
    issue?.description?.toLowerCase()?.includes(searchLower) ||
    issue?.id?.toLowerCase()?.includes(searchLower) ||
    issue?.shipmentRef?.toLowerCase()?.includes(searchLower)
    );
    setFilteredIssues(result);
  };

  const handleExport = () => {
    console.log('Exporting issues data');
    alert('Export functionality will generate CSV/Excel report with current filters applied.');
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden mt-[65px]">
        <header className="bg-card border-b border-border px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-[65px] z-20">
          <div className="flex flex-col gap-3 sm:gap-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground truncate">
                  Risk and Issue Log
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-2">
                  Track and manage project risks and issues
                </p>
              </div>
              
              <div className="flex items-center gap-2 flex-wrap">
                <Button
                  variant="outline"
                  iconName="Filter"
                  iconPosition="left"
                  onClick={() => setShowFilters(!showFilters)}
                  className="lg:hidden text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
                >
                  Filters
                </Button>
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  className="text-xs sm:text-sm px-3 sm:px-4 py-2 min-h-[44px] sm:min-h-auto"
                >
                  <span className="hidden sm:inline">Add Issue/Risk</span>
                  <span className="sm:hidden">Add</span>
                </Button>
              </div>
            </div>

            {/* Priority breakdown - responsive */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
              {/* Priority cards */}
            </div>
          </div>
        </header>

        <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
          {/* Filters - collapsible on mobile */}
          <div className={`
            ${showFilters ? 'block' : 'hidden'} lg:block
            w-full lg:w-80 flex-shrink-0 
            overflow-y-auto custom-scrollbar
            border-b lg:border-b-0 lg:border-r border-border
            max-h-[50vh] lg:max-h-none
          `}>
            <IssueFilters 
              filters={filters}
              onFilterChange={setFilters}
              onClearFilters={handleClearFilters}
              onSaveFilter={handleSaveFilter}
            />
          </div>

          <div className="flex-1 overflow-auto p-3 sm:p-4 md:p-6">
            <div className="overflow-x-auto -mx-3 sm:mx-0">
              <div className="min-w-[800px] px-3 sm:px-0">
                <IssueDataGrid 
                  issues={filteredIssues}
                  selectedIssue={selectedIssue}
                  onSelectIssue={handleSelectIssue}
                  onEditIssue={handleEditIssue}
                  onBulkAction={handleBulkAction}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssueAndRiskLog;